import { render, staticRenderFns } from "./CareplanDeleteResultDialog.vue?vue&type=template&id=522a8b7f&scoped=true&"
import script from "./CareplanDeleteResultDialog.vue?vue&type=script&lang=ts&"
export * from "./CareplanDeleteResultDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CareplanDeleteResultDialog.vue?vue&type=style&index=0&id=522a8b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a8b7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSimpleTable,VSpacer})
